import { useEffect, useRef, useState } from "react";
import style from "./ReferalAccounts.module.scss";
import {
  ApiPaginationResponse,
  PackageInfo,
  ReferalDataType,
} from "../../../interface/site.interface";
import { ReferalServices } from "../../../services/referal.service";
import TitleUpdater from "../../../components/shared/title/TitleUpdater";
import OrderRow from "../../../components/pages/courier/OrderRow";
import loginImg from "../../../assets/images/referal/login.png";
import Spinner from "../../../components/shared/spinner/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import Card from "../../../components/pages/card/Card";
import { PackagesService } from "../../../services/packages.service";
import slider from "../../../assets/images/user-admin-panel/my-packages/Sliders.svg";
import { useLocation } from "react-router-dom";
import { setRefresh } from "../../../redux/Slices/referalMainAcc";
import { fetchTranslation } from "../../../redux/Slices/translationDataSlice";
import ArrowImage from "../../../assets/images/pages/login/CaretLeft.svg";
import { $api } from "../../../api/api";
import SelectComponent from "../../../components/shared/select/SelectComponent";

function ReferalAccounts() {
  const [referal, setReferal] = useState<ReferalDataType[]>([]);
  const [loading, setLoading] = useState(true);
  const [paginationData, setPaginationData] =
    useState<ApiPaginationResponse<ReferalDataType> | null>(null);
  const [paginationDataPackages, setPaginationDataPackages] =
    useState<ApiPaginationResponse<ReferalDataType> | null>(null);
  const [showTab, setShowTab] = useState(() => {
    const savedTab = localStorage.getItem("referalActiveTab");
    return savedTab === "orders";
  });
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const refresh = useSelector((state: RootState) => state.referal.refresh);
  const [filters, setFilters] = useState(false);
  const [packagesType, setPackagesType] = useState<any[]>([]);
  const filterRef = useRef<HTMLDivElement>(null);
  const { data } = useSelector((state: RootState) => state.translationData);
  const [isLoadingList, setIsLoadingList] = useState(false);
  const language = useSelector((state: RootState) => state.language.language);
  const [selectedStatus, setSelectedStatus] = useState<{
    key: string;
    label: string;
  }>(() => {
    const savedKey =
      localStorage.getItem("referalSelectedStatusKey") || "warehouse";
    const savedLabel =
      localStorage.getItem("referalSelectedStatusLabel") || "Bakıya çatıb";
    return {
      key: savedKey,
      label: savedLabel,
    };
  });

  useEffect(() => {
    PackagesService.getAllPackagesType().then((res) => {
      const statusOptions = res.data.data.map(
        (type: { key: string; label: string }) => ({
          key: type.key,
          label: type.label,
        })
      );
      setPackagesType(statusOptions);
      const matched = statusOptions.find(
        (option: any) => option.key === selectedStatus.key
      );
      if (matched && matched.label !== selectedStatus.label) {
        setSelectedStatus(matched);
      }
    });
  }, [language]);

  useEffect(() => {
    return () => {
      localStorage.removeItem("referalActiveTab");
      localStorage.removeItem("referalSelectedStatusKey");
      localStorage.removeItem("referalSelectedStatusLabel");
    };
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target as Node)
      ) {
        setFilters(false);
      }
    };

    if (filters) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [filters]);

  const [referalList, setReferalList] = useState<PackageInfo[]>([]);
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      if (!data) {
        dispatch(fetchTranslation());
      }
    } else {
      dispatch(fetchTranslation());
    }
  }, [dispatch, language]);

  useEffect(() => {
    setIsLoadingList(true);

    ReferalServices.GetReferalList(selectedStatus.key)
      .then((res) => {
        setReferalList(res.data.original.packages.data);
        setPaginationDataPackages(res.data.original.packages);
      })
      .catch((err) => console.error("Xəta:", err))
      .finally(() => setIsLoadingList(false));
  }, [selectedStatus.key, language]);

  useEffect(() => {
    setLoading(true);
    dispatch(setRefresh(false));
    ReferalServices.GetReferal()
      .then((res) => {
        setReferal(res.data.original[0]?.data);
        setPaginationData(res.data.original[0]);
      })
      .catch(() => {
        setReferal([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [refresh, language]);

  if (loading) {
    return <Spinner size="large" />;
  }

  const handlePageChange = async (urlOrPage: string | number) => {
    setLoading(true);
    try {
      let res;
      if (typeof urlOrPage === "string") {
        res = await ReferalServices.GetReferal(urlOrPage);
      } else {
        const url = `/referal?page=${urlOrPage}`;
        res = await ReferalServices.GetReferal(url);
      }
      setReferal(res.data.original[0]?.data);
      setPaginationData(res.data.original[0]);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handlePackagesPageChange = async (urlOrPage: string | number) => {
    setLoading(true);
    try {
      let apiUrl;
      if (typeof urlOrPage === "string") {
        apiUrl = urlOrPage;
      } else {
        apiUrl = $api("get_referalList", {
          status: selectedStatus.key,
          page: urlOrPage,
        });
      }

      const res = await ReferalServices.GetReferalList(
        selectedStatus.key,
        apiUrl
      );
      setReferalList(res.data.original.packages.data);
      setPaginationDataPackages(res.data.original.packages);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <TitleUpdater
        title={
          data?.colibri && data?.auth_left_sidebar_referral_accounts
            ? `${data?.colibri} | ${data?.auth_left_sidebar_referral_accounts}`
            : "Colibri"
        }
      />
      <div className={style.ReferalHeader}>
        <div className={style.referalButtons}>
          <button
            className={`${style.AccountListBtn} ${
              !showTab ? style.active : ""
            }`}
            onClick={() => {
              setShowTab(false);
              localStorage.setItem("referalActiveTab", "list");
            }}
          >
            {data?.auth_referal_list}
          </button>
          <button
            className={`${style.ReferalListBtn} ${showTab ? style.active : ""}`}
            onClick={() => {
              setShowTab(true);
              localStorage.setItem("referalActiveTab", "orders");
            }}
          >
            {data?.auth_referal_orders}
          </button>
        </div>

        {/* {showTab && (
          <div className={style.icon} onClick={() => setFilters(!filters)}>
            <img src={slider} alt="filter" />
          </div>
        )} */}
      </div>

      {/* {showTab && filters && (
        <div ref={filterRef} className={style.filters}>
          <div className={style.status_lists}>
            {packagesType.map((el: { label: string; key: string }) => (
              <div
                key={el.key}
                className={`${style.st_list} ${
                  selectedStatus.key === el.key ? style.active : ""
                }`}
                onClick={() => {
                  setSelectedStatus(el);
                  localStorage.setItem("referalSelectedStatusKey", el.key);
                  localStorage.setItem("referalSelectedStatusLabel", el.label);
                  setFilters(false);
                }}
              >
                {el.label}
              </div>
            ))}
          </div>
        </div>
      )} */}

      {showTab ? (
        <div>
          <div className={style.pagination_part}>
            {(paginationDataPackages?.current_page === 1 &&
              paginationDataPackages?.next_page_url === null) ||
              (paginationDataPackages && (
                <div className={style.pagination}>
                  <img
                    src={ArrowImage}
                    className={`${style.pagination_arrow_left} ${
                      !paginationDataPackages.prev_page_url
                        ? style.disabled
                        : ""
                    }`}
                    alt="Prev"
                    onClick={() => {
                      if (paginationDataPackages.prev_page_url) {
                        handlePackagesPageChange(
                          paginationDataPackages.prev_page_url
                        );
                      }
                    }}
                  />

                  {[...Array(paginationDataPackages.last_page)].map(
                    (_, index) => {
                      const page = index + 1;
                      return (
                        <p
                          key={page}
                          className={`${style.pagination_count} ${
                            paginationDataPackages.current_page === page
                              ? style.active
                              : ""
                          }`}
                          onClick={() => handlePackagesPageChange(page)}
                        >
                          {page}
                        </p>
                      );
                    }
                  )}

                  <img
                    src={ArrowImage}
                    className={`${style.pagination_arrow_right} ${
                      !paginationDataPackages.next_page_url
                        ? style.disabled
                        : ""
                    }`}
                    alt="Next"
                    onClick={() => {
                      if (paginationDataPackages.next_page_url) {
                        handlePackagesPageChange(
                          paginationDataPackages.next_page_url
                        );
                      }
                    }}
                  />
                </div>
              ))}

            {showTab && (
              <div className={style.selectType}>
                <SelectComponent
                  name="status"
                  customStyles={{ borderColor: "black" }}
                  customTextStyles={{ color: "black", fontWeight: "600" }}
                  selectedValue={selectedStatus.key}
                  value={selectedStatus.key}
                  options={packagesType.map((type) => ({
                    label: type.label,
                    value: type.key,
                  }))}
                  placeholder={data?.auth_courier_select || "Status seçin"}
                  onChange={(optionValue) => {
                    const selected = packagesType.find(
                      (opt) => opt.key === optionValue
                    );
                    if (selected) {
                      setSelectedStatus(selected);
                      localStorage.setItem(
                        "referalSelectedStatusLabel",
                        selected.label
                      );
                      localStorage.setItem(
                        "referalSelectedStatusKey",
                        selected.key
                      );
                    }
                  }}
                />
              </div>
            )}
          </div>
          {isLoadingList ? (
            <div className={style.loadingContainer}>
              <Spinner size="large" />
            </div>
          ) : referalList?.length > 0 ? (
            <>
              <div className={style.order_history_wrapper}>
                <table className={style.order_history_list}>
                  <thead>
                    <tr>
                      <th>{data?.customer}</th>
                      <th>{data?.auth_common_tracking_code}</th>
                      <th>{data?.flight}</th>
                      <th>{data?.country}</th>
                      <th>{data?.weight}</th>
                      {/* <th>{data?.auth_common_category}</th> */}
                      <th>{data?.store}</th>
                      <th>{data?.invoice}</th>
                      <th>{data?.auth_courier_payment_type}</th>
                      <th>{data?.auth_common_invoice_price}</th>
                      <th>{data?.auth_common_shipping_price}</th>
                      <th>{data?.auth_referal_date}</th>
                      <th>{data?.status}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {referalList.map((order, index) => (
                      <OrderRow key={index} {...order} AllReferals={true} />
                    ))}
                  </tbody>
                </table>
              </div>
              <div className={style.courier_card}>
                {referalList.map((order, index) => (
                  <Card key={index} {...order} AllReferals={true} />
                ))}
              </div>
            </>
          ) : (
            <div className={style.emptyContainer}>
              <h4 className={style.emptyTitle}>{data?.package_not_found}</h4>
              <p className={style.emptyText}>{data?.auth_no_data_in_section}</p>
            </div>
          )}
        </div>
      ) : (
        <div>
          <div className={style.pagination_part}>
            {(paginationData?.current_page === 1 &&
              paginationData?.next_page_url === null) ||
              (paginationData && (
                <div className={style.pagination}>
                  <img
                    src={ArrowImage}
                    className={`${style.pagination_arrow_left} ${
                      !paginationData.prev_page_url ? style.disabled : ""
                    }`}
                    alt="Prev"
                    onClick={() => {
                      if (paginationData.prev_page_url) {
                        handlePageChange(paginationData.prev_page_url);
                      }
                    }}
                  />

                  {[...Array(paginationData.last_page)].map((_, index) => {
                    const page = index + 1;
                    return (
                      <p
                        key={page}
                        className={`${style.pagination_count} ${
                          paginationData.current_page === page
                            ? style.active
                            : ""
                        }`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </p>
                    );
                  })}

                  <img
                    src={ArrowImage}
                    className={`${style.pagination_arrow_right} ${
                      !paginationData.next_page_url ? style.disabled : ""
                    }`}
                    alt="Next"
                    onClick={() => {
                      if (paginationData.next_page_url) {
                        handlePageChange(paginationData.next_page_url);
                      }
                    }}
                  />
                </div>
              ))}

            {showTab && (
              <div className={style.icon} onClick={() => setFilters(!filters)}>
                <img src={slider} alt="filter" />
              </div>
            )}
          </div>
          {referal.length === 0 ? (
            <div className={style.empty}>Heç bir məlumat yoxdur.</div>
          ) : (
            <table className={style.order_history_list}>
              <thead>
                <tr>
                  <th>{data?.auth_referal_customer_code}</th>
                  <th>{data?.auth_referal_full_name}</th>
                  <th>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <img src={loginImg} alt="" />
                      <div style={{ border: "none" }}>
                        {data?.auth_referal_login}
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody style={{ borderColor: "black" }}>
                {referal?.map((order, index) => (
                  <OrderRow
                    key={index}
                    {...order}
                    referal={true}
                    setLoading={setLoading}
                  />
                ))}
              </tbody>
            </table>
          )}
          <div className={style.courier_card}>
            {referal?.map((order, index) => (
              <Card key={index} {...order} referal={true} />
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default ReferalAccounts;
